import NavigationTile from "src/components/shared/NavigationTile/NavigationTile";

type Props = {
  label: string;
  value: string;
  onClick: (name: string) => void;
};

const ChecklistLogbookCard = ({ label, onClick }: Props) => {
  return (
    <NavigationTile compact title={label} onClick={() => onClick(label)} />
  );
};

export default ChecklistLogbookCard;
